import Modal from "react-bootstrap/Modal";
import classes from "./UserModal.module.css";
import { useEffect, useState } from "react";

function UsersModal({ show, setShow, user, onUpdate, deleteLoading }) {
  const [tempUsername, setTempUsername] = useState("");

  useEffect(() => {
    if (show && user) {
      setTempUsername(user.name || "");
    }
  }, [show, user]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!tempUsername.trim() || !user) return;
    onUpdate(user, tempUsername.trim());
    setShow(false);
  };

  return user ? (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Update user&apos;s details
        </Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          <div className={"input-group w-100 " + classes.inp}>
            <p>Old Username:</p>
            <p className="ms-3">
              <b>{user.name}</b>
            </p>
          </div>
          <div className={"input-group w-100 " + classes.inp}>
            <p className="mt-2">New Username:</p>
            <input
              type="text"
              className="form-control ms-2 w-50"
              placeholder="Username"
              value={tempUsername}
              onChange={(event) => setTempUsername(event.target.value)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary me-2"
            disabled={deleteLoading}
            onClick={() => setShow(false)}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-outline-primary"
            disabled={deleteLoading || !tempUsername.trim()}
          >
            Update
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  ) : null;
}

export default UsersModal;
